<template>

  <v-jumbotron>
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h4 class="display-2 my-3">
            Thanks for joining!
          </h4>
          <span class="subheading">
            <p>Welcome to the xVIEW 2018 Object Detection Challenge.</p>
          </span>
          <span class="subheading">
            <p>This short tour will introduce you to the resources and functionalities available to you throughout the Challenge...</p>
          </span>
          <v-divider class="my-3"></v-divider>

          <div class="title my-4">Ready to begin the tour?</div>
          <v-btn to='tour1' large color="primary" dark class="mx-0">Let's go</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>

</template>

<script>
  // import firebase from 'firebase'

  export default {
    name: 'Tour',
    data () {
      return {
        // gradient: '315deg, #3f87a6, #f69d3c',
        // emailVerified: null,
        // idToken: null
      }
    },
    // methods: {
    //   updateEmailVerification () {
    //     firebase.auth().currentUser.getIdToken(true)  // force a token/state refresh
    //     .then((idToken) => {
    //       // console.log('token: ', idToken)
    //       this.$set(this.$data, 'idToken', idToken)
    //       this.$set(this.$data, 'emailVerified', firebase.auth().currentUser.emailVerified)
    //     })
    // },
    mounted () {
      console.log('Tour component mounted')
      // console.log(firebase.auth().currentUser)
    }
    // computed: {
    //   emailVerified: () => {
    //     firebase.auth().currentUser.getIdToken(true)  // force a refresh
    //     return firebase.auth().currentUser.emailVerified
    //   }
    // }
  }
</script>


// WEBPACK FOOTER //
// src/components/Tour/Tour.vue